import { render } from "./WishlistContent.vue?vue&type=template&id=3cd71e80&scoped=true"
import script from "./WishlistContent.vue?vue&type=script&lang=js"
export * from "./WishlistContent.vue?vue&type=script&lang=js"

import "./WishlistContent.vue?vue&type=style&index=0&id=3cd71e80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd71e80"]])

export default __exports__